import eio from "engine.io-client";

export const EVENT_TYPE_RESTORED = "restored";

class GoCometProvider
{
    eventListeners = {};
    channels = [];
    reconnectTimeout = 5000;

    constructor(server, reconnect)
    {
        window.socketInstance = this;

        this.socket = eio(server, {
            transports: ['websocket', 'polling'],
        });

        if (reconnect) {
            this.socket.on('open', () => {
                const now = Date.now();
                const timeSinceLastClose = this.connectionClosingTime ? now - this.connectionClosingTime : null;

                if (timeSinceLastClose && timeSinceLastClose > 60000) {
                    this.trigger(EVENT_TYPE_RESTORED);
                }

                this.connectionClosingTime = null;

                if (this.channels.length > 0) {
                    this.socket.send(JSON.stringify({
                        name: 'subscribe',
                        data: {
                            channels: this.channels,
                            version: "0.3"
                        }
                    }))
                }

                Object.keys(this.eventListeners).forEach(eventName => {
                    this.eventListeners[eventName].forEach(handler => {
                        this.socket.on(eventName, handler);
                    });
                });
            });

            this.socket.on('close', () => {
                if (!this.connectionClosingTime) {
                    this.connectionClosingTime = Date.now();
                }

                setTimeout(() => {
                    this.socket.open();
                }, this.reconnectTimeout);
            });
        }

        this.socket.on('message', (msg) => {
            try {
                msg = JSON.parse(msg);
                if (msg.name === 'message') {
                    msg.data.messages.forEach(message => {
                        const {Type, Message} = JSON.parse(message);
                        this.trigger(Type, Message);
                    })
                }
            } catch (e) {
                console.error(e);
            }
        });
    }

    join(channels)
    {
        console.log('comet join ', channels);
        this.channels = this.channels.concat(channels);

        const msg = {
            name:'subscribe',
            data:{
                channels,
//				cursor:0,
                version:"0.3"
            }
        };
        this.socket.send(JSON.stringify(msg));
    }

    leave(channels)
    {
        console.log('comet leave ', channels);
        this.channels = this.channels.filter(channel => -1 === channels.indexOf(channel));

        const msg = {
            name:'unsubscribe',
            data:{
                channels,
//				cursor:0,
                version:"0.3"
            }
        };
        this.socket.send(JSON.stringify(msg));
    }

    on(eventName, handler)
    {
        if (!(this.eventListeners[eventName] instanceof Array)) {
            this.eventListeners[eventName] = [];
        }

        this.eventListeners[eventName].push(handler);

        this.socket.on(eventName, handler);
    }

    off(eventName, handler)
    {
        if (!(this.eventListeners[eventName] instanceof Array)) {
            return;
        }

        if (handler === undefined) {
            delete this.eventListeners[eventName];

            return;
        }

        this.eventListeners[eventName] = this.eventListeners[eventName].filter(h => h !== handler);
    }

    trigger(eventName, ...args)
    {
        if (!(this.eventListeners[eventName] instanceof Array)) {
            return;
        }

        this.eventListeners[eventName].forEach(handler => handler(...args));
    }
}

export default GoCometProvider;
